module.exports = __webpack_public_path__ + "static/en-cbfe8d83119f9172fd29f8961503014a.svg";